module.exports = __webpack_public_path__ + "static/img/2845_phase_function_Paper_Points.6ddcc94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2845_phase_function_Paper_Points.png
// module id = xZNX
// module chunks = 0